import React, { useState } from 'react';
import './OurWorks.css';
import './WorkHighlightsCarousel.css';
import img1 from '../assets/work1.png';
import img2 from '../assets/work2.png';
import img3 from '../assets/work3.png';
const images = [img1, img2, img3, img1, img1];

const OurWorks = ({ works = images }) => {
  const [index, setIndex] = useState(0);
  const visible = works.slice(index, index + 3);
  const canPrev = index > 0;
  const canNext = index < works.length - 3;
  const totalDots = works.length - 2;

  const handlePrev = () => {
    if (canPrev) setIndex(index - 1);
  };
  const handleNext = () => {
    if (canNext) setIndex(index + 1);
  };
  const handleDotClick = (i) => {
    if (i >= 0 && i <= works.length - 3) setIndex(i);
  };

  return (
    <section className="ourworks-section">

      <div className="wh-carousel-header container">
        <h2 className="wh-carousel-title ourworks-title">Work Highlights</h2>
        <div className="wh-carousel-controls ourworks-arrows">
          <button className="ourworks-arrow" onClick={handlePrev} disabled={!canPrev}><div className="wh-nav-btn swiper-button-prev">
            <span></span>
          </div></button>
          <button className="ourworks-arrow" onClick={handleNext} disabled={!canNext}><div className="wh-nav-btn swiper-button-next">
            <span></span>
          </div></button>
        </div>
      </div>

      {/* <div className="container d-flex">
        <span className="ourworks-title">Work Highlights</span>
        <div className="ourworks-arrows">
          <button className="ourworks-arrow" onClick={handlePrev} disabled={!canPrev}>
            <span className="ourworks-arrow-hexagon">
              <svg width="38" height="38" viewBox="0 0 38 38"><polygon points="19,3 36,11 36,27 19,35 2,27 2,11" fill="none" stroke="#fff" strokeWidth="2"/></svg>
              <span className="ourworks-arrow-icon">&#60;</span>
            </span>
          </button>
          <button className="ourworks-arrow" onClick={handleNext} disabled={!canNext}>
            <span className="ourworks-arrow-hexagon">
              <svg width="38" height="38" viewBox="0 0 38 38"><polygon points="19,3 36,11 36,27 19,35 2,27 2,11" fill="none" stroke="#fff" strokeWidth="2"/></svg>
              <span className="ourworks-arrow-icon">&#62;</span>
            </span>
          </button>
        </div>
      </div> */}
      <div className="ourworks-carousel container">
        {visible.map((img, i) => (
          <div className="ourworks-img-wrap" key={i}>
            <img src={img} alt={`work${index + i + 1}`} className="ourworks-img" />
            <div className="ourworks-img-underline" />
          </div>
        ))}
      </div>
      <div className="ourworks-dots">
        {Array.from({ length: totalDots }).map((_, i) => (
          <span
            key={i}
            className={`ourworks-dot${i === index ? ' active' : ''}`}
            onClick={() => handleDotClick(i)}
            style={{ cursor: 'pointer' }}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default OurWorks; 